module.exports = __webpack_public_path__ + "img/car_inspection.df672765.jpg";